import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { CAR_STRUCTURE_TYPE } from "./cars.constants";

export function useCarStructures() {
  return useAccountTypeStructures(CAR_STRUCTURE_TYPE);
}
